module.exports = __webpack_public_path__ + "35575a14235408993f8db74f5169db77.svg";